import { Head, Link } from "@inertiajs/react";

import { Button } from "@/components/ui/button";
import AppLayout from "@/layouts/app-layout";
import { usersPath } from "@/routes";
import type {
  BreadcrumbItem,
  PagyMetadata,
  RansackFilters,
  User,
} from "@/types";

import { UsersDataTable } from "./data-table";
import ImportUsersDialog from "./import-dialog";

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Usuarios",
    href: usersPath(),
  },
];

interface UsersProps {
  data: {
    users: User[];
    pagy: PagyMetadata;
  };
  filters: RansackFilters;
}

export default function Users({ data, filters }: UsersProps) {
  const { users, pagy } = data;

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Usuarios" />
      <div className="flex h-full flex-1 flex-col gap-4 p-4">
        <div className="flex flex-col space-y-2">
          <h2 className="text-2xl font-bold">Usuarios</h2>
          <p className="text-muted-foreground">
            Gestiona los usuarios de la aplicación
          </p>
        </div>

        <div className="flex items-center justify-between">
          <div className="text-sm text-muted-foreground">
            Total: {pagy.count} usuarios
          </div>
          <div className="flex justify-end gap-x-2">
            <ImportUsersDialog />
            <Button asChild>
              <Link href="/users/new">Crear Usuario</Link>
            </Button>
          </div>
        </div>

        <UsersDataTable users={users} pagy={pagy} filters={filters} />
      </div>
    </AppLayout>
  );
}
